import { ErrorMessageStrategy } from '@shared/utils/interfaces';

export const singleActiveProviderConstraintStrategy: ErrorMessageStrategy = () => {
  return {
    translationKey: 'errors.SINGLE_ACTIVE_PROVIDER_CONSTRAINT',
  };
};
